<div class="product-cell">
  <glxy-avatar [width]="40" [name]="defaultName" [src]="iconUrl"></glxy-avatar>
  <div class="product-name-type">
    <div class="product-name">
      {{ defaultName }}
    </div>
    <div *ngIf="deliveryMethod">{{ deliveryMethod | formatDeliveryMethod }}</div>
    <div *ngIf="ownerName">by {{ ownerName }}</div>
    <div *ngIf="requiredItems?.length > 0">
      <div *ngIf="type === ItemType.ITEM_TYPE_ADDON; else app">Add-on to {{ requiredItemNames[0] }}</div>
      <ng-template #app>
        Requires
        <span *ngFor="let name of requiredItemNames; let isLast = last">
          <span *ngIf="!isLast">{{ name }},&nbsp;</span>
          <span *ngIf="isLast">{{ name }}</span>
        </span>
      </ng-template>
    </div>
  </div>
</div>
